module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<!-- assets/scripts/templates/factfinder-suggest-brand.lodash.tpl -->\n<div class="mdl_search__section mdl_search__section--results">\n    <div class="mdl_search__section-header">\n        <div class="mdl_search__section-title">' +
((__t = ( window.StringTranslation.get( 'BRAND_SUGGESTIONS_HEADING' ) )) == null ? '' : __t) +
'</div>\n    </div>\n    <div class="mdl_search__section-content">\n        ';
 suggestions.forEach( ( brand ) => { ;
__p += '\n        <a href="' +
((__t = ( brand.Deeplink )) == null ? '' : __t) +
'" class="mdl_search__suggestions-brand" data-suggest="' +
((__t = ( brand.dataSuggest )) == null ? '' : __t) +
'">\n            ' +
((__t = ( mark( brand.name ) )) == null ? '' : __t) +
'\n            ';
 if ( brand.hitCount ) { ;
__p += '\n            <span class="mdl_search__suggestions-itemcount">' +
((__t = ( getCount( brand.hitCount ) )) == null ? '' : __t) +
'</span>\n            ';
 } ;
__p += '\n        </a>\n        ';
 }) ;
__p += '\n    </div>\n</div>\n';

}
return __p
};
